import {instance} from "../../config/axios-cnf";


export const apiGetValidateTicket = (values, callback, error) => {
    instance.get("/api/v2/validate", {params: values})
        .then(response => callback(response.data))
        .catch(err => error(err))
}
